import React from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn-lite';

import withRouter from 'hoc/withRouter';

import './LoaderBar.scss';

const UPDATE_INTERVAL = 500;
const b = block('LoaderBar');

class LoaderBar extends React.Component {
    static propTypes = {
        router: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.timerId = null;
        this.state = {
            loading: false,
            value: 0,
        };
    }

    componentDidMount() {
        const {router} = this.props;

        router.events.on('routeChangeStart', this.handleRouteChangeStart);
        router.events.on('routeChangeComplete', this.handleRouteChangeComplete);
    }

    componentWillUnmount() {
        const {router} = this.props;

        clearTimeout(this.timerId);
        router.events.off('routeChangeStart', this.handleRouteChangeStart);
        router.events.off('routeChangeComplete', this.handleRouteChangeComplete);
    }

    updateProgress(value) {
        this.setState({value: Math.min(value, 95)});
        this.timerId = setTimeout(() => this.updateProgress(value + 3), UPDATE_INTERVAL);
    }

    handleRouteChangeStart = () => {
        clearTimeout(this.timerId);
        requestAnimationFrame(() => {
            this.setState(
                {
                    value: 0,
                    loading: true,
                },
                () => requestAnimationFrame(() => this.updateProgress(12)),
            );
        });
    };

    handleRouteChangeComplete = () => {
        clearTimeout(this.timerId);
        requestAnimationFrame(() => {
            this.setState({
                value: 100,
                loading: false,
            });
        });
    };

    render() {
        const {loading, value} = this.state;
        const progressStyle = {
            width: value + '%',
            transition: value === 0 ? 'none' : null,
        };

        return (
            <div className={b({loading})}>
                <div className={b('progress')} style={progressStyle} />
            </div>
        );
    }
}

export default withRouter(LoaderBar);
